import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const InboxPanel = () => {
  const [isOpen, setIsOpen] = useState(true);
  const tenantName = localStorage.getItem('tenantName');
  
  return (
    <div className="chat-inbox-panel col-md-2">
      <div className="chat-inbox-header">
        <h4 className="chat-inbox-title">Inbox</h4>
      </div>
      
      <nav className="chat-inbox-nav">
        {/* Expandable Conversations Section */}
        <div className="chat-inbox-section">
          <div 
            className={`chat-inbox-section-header ${isOpen ? 'open' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="chat-inbox-section-title">
              <i className="mdi mdi-message-text chat-inbox-icon"></i>
              <span>Live Conversations</span>
            </div>
            <i className={`mdi mdi-chevron-${isOpen ? 'down' : 'right'} chat-inbox-chevron`}></i>
          </div>
          
          {isOpen && (
            <div className="chat-inbox-section-content">
              <Link 
                to={`/${tenantName}/chat/Conversation/Unassigned/:collection`} 
                className="chat-inbox-link"
              >
                Unassigned
              </Link>
              <Link 
                to={`/${tenantName}/chat/Conversation/MyOpen/:collection`} 
                className="chat-inbox-link"
              >
                My Open
              </Link>
              <Link 
                to={`/${tenantName}/chat/Conversation/Solved/:collection`} 
                className="chat-inbox-link"
              >
                Solved
              </Link>
            </div>
          )}
        </div>
        
        {/* Tickets Link */}
        <Link 
          to={`/${tenantName}/chat/tickets`} 
          className="chat-inbox-item"
        >
          <i className="mdi mdi-ticket-confirmation chat-inbox-icon"></i>
          <span>Tickets</span>
        </Link>
      </nav>
    </div>
  );
};

export default InboxPanel;